import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'

interface Props {
  checked: boolean
  answerKey: string
  onClick: () => void
  picture: string
  pictureSelected: string
  children?: any
}

export const PictureAnswer = (props: Props) => {
  const handleClick = (e) => {
    const { onClick } = props
    e.preventDefault()
    onClick()
  }

  const { answerKey, checked, children, picture, pictureSelected } = props
  return (
    <Container
      id={answerKey}
      onClick={(e) => handleClick(e)}
      color={checked ? 'white' : '#4a4a4a'}
      highlightColor={checked ? '#a7c9cd' : 'white'}>
      <img alt='funeral_pic' src={checked ? pictureSelected : picture} />
      {children}
    </Container>
  )
}

const Container = styled.button`
  width: 180px;
  height: 150px;
  margin: 5px;
  padding: 3%;
  background: ${(props) => props.highlightColor};
  font-size: 17px;
  outline: none;
  border: 2px solid #a7c9cd;
  border-radius: 0;
  color: ${(props) => props.color};

  ${media.tablet` width: 100%; `}

  & > p {
    margin: 0;
    font-size: 17px;
    line-height: 1.2;
  }

  & > img {
    width: 75px;
  }
`

export default PictureAnswer



// WEBPACK FOOTER //
// ./src/components/atoms/wizard/PictureAnswer.tsx